import {Checkbox, makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import {useHistory} from "react-router";
import UtilService from '../../../../../helper/service';

import roles from "../../../../../helper/roles";
import {useCallback} from "react";

const useStyles = makeStyles(() => ({
  tr: {
    minHeight: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'roboto-regular',
    color: '#697683',
    fontSize: 14,
    borderBottom: '1px solid #F5F5F5',
    padding: '6px 8px',
    background: '#ffffff',
    '& div': {
      textAlign: 'left'
    },
  },
  mp3Icon: {
    width: '30px',
    // height: '38px',
    position: 'absolute',
    textAlign: 'center',
    marginLeft: '24px',
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },
  img: {
    width: 83,
    height: 52,
    borderRadius: 10,
    marginRight: 25
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'roboto-regular',
    fontSize: 14
  },
}));

export function CreatorReelsTableSubBody(props: any) {

  const classes = useStyles();
  const history = useHistory();
  
  const { selected, disableNavigation, onChangeSelected, clip, HEADER } = props;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  
  const goManagerParticipantPage = () => {
    if (disableNavigation) return;

    if (!clip.session_code) return;
    
    localStorage.setItem("session_code", String(clip.session_code));
    localStorage.setItem("session_id", String(clip.session_id));
    localStorage.setItem("session_name", String(clip.name));

    let routerTabName = 'participants';
    switch (clip.session_status.toLowerCase()) {
      case "upcoming":
        routerTabName = "participants";
        break;
      case "completed":
        routerTabName = "overview";
        break;
      case "live":
        routerTabName = "analyze";
        break;
      default:
        break;
    }

    let url = `/creator/experience-manager/${routerTabName}/${clip.session_code}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/${routerTabName}/${clip.session_code}`;
    }
    history.push(url, { session_id: clip.session_id });
  };

  const showSafety = useCallback(() => {
    const length = Number(clip?.session_length);
    return UtilService.isShowSafety(clip?.session_type, length);
  }, [clip]);
  
  return (
    <div className={classes.tr}>
      <div style={{ width: HEADER[0].width }}>
        {<Checkbox
          checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
          icon={<span className={classes.icon} />}
          color="primary"
          checked={(selected?.findIndex((x: any) => x.session_id === clip.session_id)) !== -1}
          onChange={() => onChangeSelected(clip)}
          style={{ marginLeft: -8 }}
        />}
      </div>

      <div
        className={classes.left}
        onClick={() => goManagerParticipantPage()}
        style={{ width: HEADER[1].width }}
      >
          <img
            src={clip.small_thumbnail ? clip.small_thumbnail : clip.large_thumbnail ? clip.large_thumbnail : '/assets/images/video-processing.png'}
            alt={'img'}
            className={classes.img}
            onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
          />
          {(clip.stimulus_type === 'AUDIO') && (
            <img
              src={`/assets/icons/mp3.svg`}
              alt={'img'}
              className={classes.mp3Icon}
              onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
            />
          )}
        {clip.session_title}
      </div>

      <div
        className={classes.healthyText}
        style={{ width: HEADER[2].width, color: UtilService.refactorGraphColor(clip.immersion_color_indicator) }}
      >
        {clip.immersion_index ? clip.immersion_index : "-"}
      </div>

      <div
        className={classes.healthyText}
        style={{ width: HEADER[3].width, color: UtilService.refactorGraphColor(clip.safety_color_indicator) }}
      >
        {(showSafety() && clip.safety_index > 1) ? clip.safety_index : '-'}
      </div>

      <div style={{ width: HEADER[4].width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.formattingString(clip.session_status)}
      </div>

      <div style={{ width: HEADER[5]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(clip.started_at ? clip.started_at : clip.scheduled_start_at)}
      </div>

      <div style={{ width: HEADER[6]?.width }} onClick={() => goManagerParticipantPage()}>
        {UtilService.getSimpleDate(clip.ended_at ? clip.ended_at : clip.scheduled_end_at)}
      </div>

      <div style={{ width: HEADER[7]?.width }} onClick={() => goManagerParticipantPage()}>
        {clip.participantscount}
      </div>

    </div>
  )
}